/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

interface Props {
  placeholder?: string
}

export const EditorPlaceholder = ({ placeholder = 'Type text...' }: Props) => {
  return <div className='editor-placeholder position-absolute'>{placeholder}</div>;
};
